module.exports = __webpack_public_path__ + "static/media/tag.c250430f.svg";